import { apiClient } from './api-client';
import { StandardizedAnalysis, AnalysisStatus, AnalysisRun } from '@/types/index';

export const pdfAnalysisService = {
  async analyzeWithRAG(propertyId: string): Promise<{ status: string }> {
    return apiClient.post<{ status: string }>(`/pdf-analysis/analyze/${propertyId}`);
  },

  async getIndicators(propertyId: string): Promise<StandardizedAnalysis | null> {
    return apiClient.get<StandardizedAnalysis | null>(`/pdf-analysis/indicators/${propertyId}`);
  },

  async getAnalysisStatus(propertyId: string): Promise<AnalysisStatus> {
    return apiClient.get<AnalysisStatus>(`/pdf-analysis/status/${propertyId}`);
  },

  async getHistory(propertyId: string): Promise<AnalysisRun[]> {
    return apiClient.get<AnalysisRun[]>(`/pdf-analysis/history/${propertyId}`);
  },

  async deleteRun(runId: string): Promise<void> {
    await apiClient.delete(`/pdf-analysis/runs/${runId}`);
  },

  async deleteDocumentsAndVectors(propertyId: string): Promise<void> {
    await apiClient.delete(`/pdf-analysis/documents/${propertyId}`);
  },
};
